﻿import { FC, HTMLAttributes } from 'react';

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'info' | 'success' | 'warning' | 'error';
  title?: string;
}

export const Alert: FC<AlertProps> = ({ children, variant = 'info', title, className = '', ...props }) => {
  return (
    <div
      role={variant === 'error' ? 'alert' : 'status'}
      className={`cs-alert cs-alert-${variant} ${className}`.trim()}
      {...props}
    >
      {title && <div style={{ fontWeight: 700, marginBottom: '0.25rem' }}>{title}</div>}
      <div>{children}</div>
    </div>
  );
};

